import React from 'react';
import { useState, useEffect } from "react";
import apiAdm from '../../../services/apiAdm';
import { FiSave, FiXCircle } from "react-icons/fi";
import { SweetAlertSuccess, SweetAlertError } from '../../../components/sweetAlert/swetAlert.jsx';
import { useNavigate, useParams } from "react-router-dom";

function CrudUsuario() {

    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [titulo, setTitulo] = useState('');
    const [disable, setDisable] = useState(false);
    const [status, setStatus] = useState('S');

    const params = useParams();

    function Cancelar() {
        window.history.back();
    };

    function Salvar() {
        if (nome == '') {
            SweetAlertError({ texto: 'Falta informar o nome.' });
            return;
        };
        if (email == '') {
            SweetAlertError({ texto: 'Falta informar o e-mail.' });
            return;
        }

        const json = {
            nome: nome,
            login: email,
            isAtivo: status,
            idEmpresa: localStorage.getItem('idEmpresa')
        };

        if (params.id == 0) {
            apiAdm.post("/usuario/vincular", json)
                .then((resp) => {
                    SweetAlertSuccess({ texto: 'Registro salvo com sucesso.' });
                })
                .catch((err) => {
                    console.log(err);
                    SweetAlertError({ texto: 'Falha ao salvar o registro, tente novamente.'  });
                });
        } else {
            apiAdm.put("/usuario/" + params.id, json)
                .then((resp) => {
                    SweetAlertSuccess({ texto: 'Registro salvo com sucesso.' });
                })
                .catch((err) => {
                    SweetAlertError({ texto: 'Falha ao salvar o registro, tente novamente.' });
                });

        };
        window.history.back();
    };

    useEffect(() => {
        if (params.id == 0) {
            setTitulo('Novo usuário');
            setDisable(false);
        } else {
            setTitulo('Editar usuário');
            setDisable(true);
            apiAdm.get("/usuario/" + params.id)
                .then((resp) => {
                    console.log(resp);
                    setNome(resp.data.data.nome);
                    setEmail(resp.data.data.login);
                    setStatus(resp.data.data.isAtivo);
                })
                .catch((err) => {
                    SweetAlertError({ texto: 'Erro ao carregar os dados do usuário.' + err });
                });
        }
    }, []);

    function ChangeStatus(e) {
        setStatus(e.target.value);
    };

    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="row">
                    <div className="col-md-10 py-3">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="text-muted mb-3">{titulo}</h5>

                                <div className="panel-container show">
                                    <div className="panel-content">
                                        <div className="row mb-3">
                                            <div className="form-group col-sm-2">
                                                <label for="selectOptante" className="form-label">Status</label>
                                                <select className="form-select" onChange={ChangeStatus} value={status}>
                                                    <option value="S">Ativo</option>
                                                    <option value="N">Inativo</option>

                                                </select>
                                            </div>
                                            <div className="form-group col-sm-5">
                                                <label for="fantasia" className="form-label">Nome</label>
                                                <input type="text" className="form-control" onChange={(e) => setNome(e.target.value)} value={nome} />
                                            </div>
                                            <div className="form-group col-sm-5">
                                                <label for="fantasia" className="form-label">e-mail</label>
                                                <input type="text" disabled={disable} className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <br></br>
                        <div div className="row mb-3">
                            <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>
                                <button type="button" style={{ margin: 15 }} className="btn btn-outline-secondary float-right"
                                    onClick={() => Cancelar()}>
                                    <FiXCircle /><span> Cancelar </span>
                                </button>
                                <button type="button" className="btn btn-primary "
                                    onClick={() => Salvar()}>
                                    <FiSave /><span> Salvar </span>
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </>


};

export default CrudUsuario;